module.exports = __webpack_public_path__ + "img/587-42dfb3.png";